const MAPS_URL =
  'https://www.google.com/maps/dir/?api=1&destination=Cvetkovci%2050%2C%202273%20Podgorci';

export default function CtaSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative h-[70vh] md:h-[80vh] min-h-[450px] overflow-hidden bg-background-950">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/4b3628b182ad10c089c4ada0dac55289.png"
          alt="Večerna jedilnica Gostilne Marta"
          title="Gostilna Marta – dobrodošli"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/55 to-black/40"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full px-5 text-center">
        <h2 className="cta-animate font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-white font-light mb-4 md:mb-6">
          Se vidimo pri Marti?
        </h2>
        <p className="cta-animate font-heading text-lg sm:text-xl md:text-2xl italic text-white/70 mb-8 md:mb-10">
          Pridi na kosilo, ostani zaradi vzdušja.
        </p>
        <div className="cta-animate flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 w-full px-6 sm:px-0 max-w-sm sm:max-w-none">
          <a
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-7 py-4 sm:py-3 bg-primary-500 hover:bg-primary-600 text-background-950 text-sm sm:text-xs font-label font-semibold tracking-extra-wide transition-all duration-300 whitespace-nowrap rounded-md sm:rounded-sm cursor-pointer"
          >
            <i className="ri-map-pin-line"></i>NAVODILA ZA POT
          </a>
          <button
            onClick={() => scrollTo('ponudba')}
            className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-7 py-4 sm:py-3 border border-white/40 hover:border-white/80 text-white text-sm sm:text-xs font-label font-medium tracking-extra-wide transition-all duration-300 whitespace-nowrap cursor-pointer rounded-md sm:rounded-sm hover:bg-white/10"
          >
            OGLEJ SI PONUDBO
          </button>
        </div>
      </div>
    </section>
  );
}